import { render, staticRenderFns } from "./DesignFormAuthEditModal.vue?vue&type=template&id=5bb84091&scoped=true&"
import script from "./DesignFormAuthEditModal.vue?vue&type=script&lang=js&"
export * from "./DesignFormAuthEditModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5bb84091",
  null
  
)

export default component.exports